import { getSections } from "@/data/questionnaire";

const byIdFor = (type) => Object.fromEntries(getSections(type).flatMap((s) => s.questions).map((q) => [q.id, q]));

export const STAFF_ROLES = ["Sala", "Cucina", "Sala e cucina", "Altro (pulizie, ufficio, allestimenti)"];

export const getStaffQuestions = (type) => {
  const byId = byIdFor(type);
  const opts = (qid) => byId[qid].options;
  return [
  { id: "st1", type: "text", placeholder: "Scrivi liberamente, anche poche righe.", compareTo: "q4",
    text: "Cosa funziona meglio oggi al Casale, e cosa invece non funziona?" },
  { id: "st2", type: "single", compareTo: "q9", options: opts("q9"),
    text: "Come viene coordinato un evento, dal primo contatto al giorno stesso?" },
  { id: "st3", type: "multiple", compareTo: "q10", options: opts("q10"), hint: "Puoi scegliere più risposte.",
    text: "Dove nascono di solito gli intoppi?" },
  { id: "st4", type: "scale", min: 1, max: 5, lowLabel: "Per niente", highLabel: "Molto",
    text: "Quanto funziona la comunicazione tra sala e cucina?" },
  { id: "st5", type: "scale", min: 1, max: 5, lowLabel: "Mai", highLabel: "Sempre",
    text: "Prima di un evento sai con chiarezza cosa devi fare, quando e con chi?" },
  { id: "st6", type: "single", compareTo: "q23", options: opts("q23"),
    text: "Se i titolari mancassero per due settimane, cosa succederebbe?" },
  { id: "st7", type: "text", placeholder: "Piatti simbolo, prodotti, modo di lavorare…", compareTo: "q13",
    text: "Cosa non deve cambiare nel menù e nello stile del Casale?" },
  { id: "st8", type: "multiple", compareTo: "q14", options: opts("q14"), hint: "Puoi scegliere più risposte.",
    text: "Cosa serve davvero nel prossimo chef?" },
  { id: "st9", type: "single", compareTo: "q16", options: opts("q16"),
    text: "Su cosa dovrebbe concentrarsi per primo l'intervento?" },
  { id: "st10", type: "text", placeholder: "Una cosa sola, quella che conta di più.",
    text: "Se potessi cambiare una sola cosa domani, quale sarebbe?" },
  ];
};

export const STAFF_QUESTIONS = new Proxy([], {
  get(_, prop) {
    const t = getStaffQuestions();
    const v = t[prop];
    return typeof v === "function" ? v.bind(t) : v;
  },
});

export const compareValues = (type, owner, staff) => {
  if (type === "multiple") {
    const o = owner || [];
    const s = staff || [];
    return { common: o.filter((x) => s.includes(x)), onlyOwner: o.filter((x) => !s.includes(x)), onlyStaff: s.filter((x) => !o.includes(x)) };
  }
  if (type === "single") return { same: owner !== undefined && owner === staff };
  return {};
};

export const staffToText = (sub) => {
  const list = sub.staff?.filter((p) => p.status === "completed") || [];
  if (list.length === 0) return "";
  const fmt = (q, v) => (v === undefined || v === "" || (Array.isArray(v) && v.length === 0) ? "(non risposto)" : Array.isArray(v) ? v.join(", ") : q.type === "scale" ? `${v} su ${q.max}` : String(v));
  return list
    .map((p) => `[${p.name} — ${p.role}]\n` + getStaffQuestions(sub.businessType).map((q) => `- ${q.text}${q.compareTo ? ` (confronto con la domanda ${q.compareTo} dei titolari)` : ""}\n  Risposta: ${fmt(q, p.answers[q.id])}`).join("\n"))
    .join("\n\n");
};
